/* Derived view-model for the access route.
 * GENERATED from the original artifact's vals_access() by
 * tools/convert-logic.py; edits since generation are tracked in git. */
import { FOOTER_COLS } from '@/data/wft';

export function accessVals() {
  return {
    footerCols: FOOTER_COLS,
    steps: [
      { n: '1', what: 'infrastructure', cmd: 'docker compose up -d postgres redis' },
      {
        n: '2',
        what: 'python environment',
        cmd: 'py -3.11 -m venv .venv && .venv\\Scripts\\activate',
      },
      {
        n: '3',
        what: 'dependencies',
        cmd: 'pip install -r requirements-torch-cpu.txt\npip install -r requirements-dev.txt',
      },
      {
        n: '4',
        what: 'configuration',
        cmd: 'cp .env.example .env    # blanks disable their connector cleanly',
      },
      { n: '5', what: 'migrations', cmd: 'alembic upgrade head' },
      { n: '6', what: 'frontend', cmd: 'cd frontend && npm install && npm run dev    # :3100' },
    ],
    ports: [
      { svc: 'Postgres', port: '5433', default: 'not 5432' },
      { svc: 'Redis', port: '6380', default: 'not 6379' },
      { svc: 'API', port: '8110', default: 'not 8000' },
      { svc: 'Frontend', port: '3100', default: 'not 3000' },
    ],
    env: [
      { key: 'FRED_API_KEY', gives: 'Rates, Macro and parts of Cockpit', cost: 'free · instant' },
      {
        key: 'SEC_CONTACT',
        gives: 'Filings — a contact string for the fair-use user agent',
        cost: 'free',
      },
      { key: 'POLYGON_API_KEY', gives: 'Intraday equity coverage', cost: 'paid · optional' },
      {
        key: 'FINNHUB_API_KEY',
        gives: 'Supplementary equity and filing data',
        cost: 'paid · optional',
      },
      { key: 'TWELVEDATA_API_KEY', gives: 'Intraday FX and equities', cost: 'paid · optional' },
    ],
    docs: [
      { file: 'docs/API_KEYS.md', what: 'which keys unlock which sections' },
      { file: 'docs/RUNBOOK.md', what: 'operating the stack day to day' },
      { file: 'docs/AWS_DEPLOY.md', what: 'deployment' },
      { file: 'docs/FORECAST_BENCHMARK.md', what: 'benchmark method behind the record' },
      { file: 'docs/STATUS.md', what: 'what is bound today' },
    ],
    ops: [
      {
        label: 'Never in git',
        body: 'The weights file is gitignored and never enters git-lfs. It is fetched, verified and placed by a script.',
      },
      {
        label: 'Verified, then renamed',
        body: 'Size and sha256 must match the recorded checksums before the file is moved into place.',
      },
      {
        label: 'Vendored layer is read-only',
        body: 'A modified file under temporal/ fails CI. Product behaviour belongs in wft/forecast/.',
      },
      {
        label: 'Own migration lineage',
        body: 'World Finance Terminal keeps its own alembic history from 0001 rather than sharing a sibling project\u2019s.',
      },
    ],
  };
}

export type AccessVals = ReturnType<typeof accessVals>;
